import { Price } from "../types/prices";
import { PriceDisplayGroup } from "../types/product";

/**
   * We are calculating volume discount based on total or base price (based on setup fee amount) because website pricing rounds off unit prices,
   * which can result in incorrect discount percentages.
   * To fix this, we calculate the per-unit prices ourselves:
   * - discounted price per unit = discountedTotal / quantity
   * - list price per unit = listTotal / moq
   * Then we calculate the discount percentage based on these per-unit prices.
   */
function calculateTotalSavings(discountedPrice: Price, listPriceForMoq: Price, isVatInclusive: boolean, quantity: number, moq: number): number {
  const listPriceForMoqValue = isVatInclusive ? listPriceForMoq.taxed : listPriceForMoq.untaxed;
  const discountedPriceValue = isVatInclusive ? discountedPrice.taxed : discountedPrice.untaxed;
  const unitListPriceForMoq = listPriceForMoqValue / moq;
  const unitDiscountedPrice = discountedPriceValue / quantity;
  const savings = getPercentage(unitDiscountedPrice, unitListPriceForMoq);
  return savings;
}

function isDiscounted(totalListPrice: Price, totalDiscountedPrice: Price, isVatInclusive: boolean) {
  const listPrice = isVatInclusive ? totalListPrice.taxed : totalListPrice.untaxed;
  const discountedPrice = isVatInclusive ? totalDiscountedPrice.taxed : totalDiscountedPrice.untaxed;
  return listPrice !== discountedPrice;
}

function getPercentage(value: number, referenceValue: number) {
  return Math.round((1 - value / referenceValue) * 100);
}

function isRangePriceDisplayGroup(priceDisplayGroup: string | undefined): boolean {
  return priceDisplayGroup?.startsWith(PriceDisplayGroup.RANGED) || false;
}

function isEachPriceDisplayGroup(priceDisplayGroup: string): boolean {
  return priceDisplayGroup === PriceDisplayGroup.EACH;
}

function isEmptyPrice(price?: Price): boolean {
  return !price || (price.taxed === 0 && price.untaxed === 0);
}

export { calculateTotalSavings, isDiscounted, isEachPriceDisplayGroup, isEmptyPrice, isRangePriceDisplayGroup };
